import { makeStyles } from "@material-ui/core";
export default makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(2),
    paddingTop: theme.spacing(5),
  },
  btn: {
    marginTop: theme.spacing(2),
  },
  form: {
    maxWidth: 600,
    display: "block",
    margin: "0 auto 10px auto",
    paddingBottom: theme.spacing(5),
  },
  input: {
    display: "none",
    marginTop: theme.spacing(2),
  },
  editor: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
}));
